import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';

class UserModule {
}
UserModule.ɵfac = function UserModule_Factory(t) { return new (t || UserModule)(); };
UserModule.ɵmod = i0.ɵɵdefineNgModule({ type: UserModule });
UserModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [],
                exports: [],
            }]
    }], null, null); })();

/*
 * Public API Surface of user
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UserModule };
//# sourceMappingURL=play-user.js.map
